"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  az: {
    code: 'az_AZ',
    alpha: 'abcçdeəfgğhxıijkqlmnoöprsştuüvyz',
    bigAlpha: 'ABCÇDEƏFGĞHXIİJKQLMNOÖPRSŞTUÜVYZ'
  },
  en: {
    code: 'en_US',
    alpha: 'abcdefghijklmnopqrstuvwxyz',
    bigAlpha: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
  },
  ru: {
    code: 'ru_RU',
    alpha: 'абвгдеёжзийклмнопрстуфхцчшщъыьэюя',
    bigAlpha: 'АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ'
  }
};
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJheiIsImNvZGUiLCJhbHBoYSIsImJpZ0FscGhhIiwiZW4iLCJydSIsImV4cG9ydHMiLCJfZGVmYXVsdCJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYnJhcnkvc3JjL2NsaWVudC9pMThuL2NvbmZpZy5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCB7XHJcbiAgICBhejoge1xyXG4gICAgICAgIGNvZGU6ICdhel9BWicsXHJcbiAgICAgICAgYWxwaGE6ICdhYmPDp2RlyZlmZ8SfaHjEsWlqa3FsbW5vw7ZwcnPFn3R1w7x2eXonLFxyXG4gICAgICAgIGJpZ0FscGhhOiAnQUJDw4dERcaPRkfEnkhYScSwSktRTE1OT8OWUFJTxZ5UVcOcVllaJyxcclxuICAgIH0sXHJcbiAgICBlbjoge1xyXG4gICAgICAgIGNvZGU6ICdlbl9VUycsXHJcbiAgICAgICAgYWxwaGE6ICdhYmNkZWZnaGlqa2xtbm9wcXJzdHV2d3h5eicsXHJcbiAgICAgICAgYmlnQWxwaGE6ICdBQkNERUZHSElKS0xNTk9QUVJTVFVWV1hZWicsXHJcbiAgICB9LFxyXG4gICAgcnU6IHtcclxuICAgICAgICBjb2RlOiAncnVfUlUnLFxyXG4gICAgICAgIGFscGhhOiAn0LDQsdCy0LPQtNC10ZHQttC30LjQudC60LvQvNC90L7Qv9GA0YHRgtGD0YTRhdGG0YfRiNGJ0YrRi9GM0Y3RjtGPJyxcclxuICAgICAgICBiaWdBbHBoYTogJ9CQ0JHQktCT0JTQldCB0JbQl9CY0JnQmtCb0JzQndCe0J/QoNCh0KLQo9Ck0KXQptCn0KjQqdCq0KvQrNCt0K7QrycsXHJcbiAgICB9XHJcbn07XHJcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7O2VBQWU7RUFDWEEsRUFBRSxFQUFFO0lBQ0FDLElBQUksRUFBRSxPQUFPO0lBQ2JDLEtBQUssRUFBRSxrQ0FBa0M7SUFDekNDLFFBQVEsRUFBRTtFQUNkLENBQUM7RUFDREMsRUFBRSxFQUFFO0lBQ0FILElBQUksRUFBRSxPQUFPO0lBQ2JDLEtBQUssRUFBRSw0QkFBNEI7SUFDbkNDLFFBQVEsRUFBRTtFQUNkLENBQUM7RUFDREUsRUFBRSxFQUFFO0lBQ0FKLElBQUksRUFBRSxPQUFPO0lBQ2JDLEtBQUssRUFBRSxtQ0FBbUM7SUFDMUNDLFFBQVEsRUFBRTtFQUNkO0FBQ0osQ0FBQztBQUFBRyxPQUFBLGNBQUFDLFFBQUEifQ==